import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { useTheme } from '../../providers';
import { Icon } from '../../ui/Icon';
import { rem } from '../../utils';
const CONTROLLER_WIDTH = {
    shadow: 22,
    outline: 28,
};
export const StyledWrapper = styled.div `
  position: relative;
  width: 100%;

  ${({ theme, variant }) => variant.style === 'outline' &&
    css `
      border-radius: ${rem(theme.Border.Radius.Medium)};
      overflow: hidden;
    `}
`;
export const StyledList = styled.div `
  display: flex;
  width: calc(100% - ${({ theme }) => rem(theme.Spacing.Size.Small * 2)});
  margin: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scroll-padding: 50%;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};

  border-radius: ${({ theme }) => rem(theme.Border.Radius.Large)};

  ${({ theme, variant }) => css `
    scroll-margin-left: ${rem(CONTROLLER_WIDTH[variant.style])};
    padding: ${variant.style === 'outline'
    ? `${rem(theme.Spacing.Size.XXSmall)} ${rem(CONTROLLER_WIDTH.outline + theme.Spacing.Size.XXSmall)}`
    : '0'};
  `}

  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    appearance: none;
  }
`;
export const StyledItemWrapper = styled.div `
  margin-right: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  scroll-snap-align: center;

  &:last-child {
    margin-right: 0;
  }
`;
export const ButtonStyle = styled.a `
  position: absolute;
  height: 100%;
  top: 0;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};
  cursor: pointer;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};

  ${({ variant, theme }) => {
    switch (variant.style) {
        case 'outline':
            return css `
          width: ${rem(CONTROLLER_WIDTH.outline)};
          background: ${theme.Components.Panel.Background};
          border-style: solid;
          border-color: ${theme.Color.Neutrals.Border};
          border-width: 0;
        `;
        case 'shadow':
        default:
            return `
            width: ${rem(CONTROLLER_WIDTH.shadow)};
            background: linear-gradient(
              90deg,
              ${theme.Components.Panel.Background} 65.62%,
              ${theme.Color.Neutrals.Dark} 100%
            );
            `;
    }
}}

  ${({ variant, visible }) => {
    switch (variant.visibility) {
        case 'visible':
            return `
          opacity: 1;
          svg {
            opacity: ${visible ? 1 : 0.25};
          }
        `;
        case 'auto':
            return `
        opacity: ${visible ? 1 : 0};
        `;
        case 'hidden':
            return `
          display: none;
        `;
    }
}}

  svg {
    position: absolute;
    width: ${({ variant }) => rem(CONTROLLER_WIDTH[variant.style])};
    height: 20px;
    top: calc(50% - 8px);
    transform: rotate(180deg);
  }
`;
export const Controller = ({ className, visible, variant, onClick, }) => {
    const theme = useTheme();
    return (_jsx(ButtonStyle, { visible: visible, className: className, variant: variant, onClick: onClick, children: _jsx(Icon, { name: 'chevron---right', color: theme.Button.Variant.Outline.Color.Content }) }));
};
export const PreviousController = styled(Controller) `
  left: 0;

  ${({ theme, variant }) => variant.style === 'outline' &&
    css `
      border-right-width: ${rem(theme.Border.Size.Small)};
      border-top-left-radius: ${rem(theme.Border.Radius.Large)};
      border-bottom-left-radius: ${rem(theme.Border.Radius.Large)};
    `}

  svg {
    left: 0;
  }
`;
export const NextController = styled(Controller) `
  right: 0;

  ${({ theme, variant }) => {
    if (variant.style === 'outline') {
        return css `
        border-left-width: ${rem(theme.Border.Size.Small)};
        border-top-right-radius: ${rem(theme.Border.Radius.Large)};
        border-bottom-right-radius: ${rem(theme.Border.Radius.Large)};

        svg {
          transform: rotate(0deg);
        }
      `;
    }
    return 'transform: matrix(-1, 0, 0, 1, 0, 0);';
}}

  svg {
    right: 0;
  }
`;
//# sourceMappingURL=ScrollableCarousel.style.js.map